<template>
  <div id="func-14-resumo-cobranca">
    <funcionalidade-header titulo="Resumo da Cobrança">
    </funcionalidade-header>
    <el-row :gutter="30">
      <el-col class="col-print" :span="13">
        <el-row style="margin-bottom: 20px; margin-top: 10px; position: sticky;">
          <el-col :span="19">
            <span class="font cobranca-title">{{tituloDetalhe}}</span>
            <span class="font cobranca-vencimento"> Vencimento: {{vencimento}}</span>
          </el-col>
          <el-col :span="5">
            <span class="font cobranca-title align-right">{{parseValor}}</span>
          </el-col>
        </el-row>
        <div v-for="(registro, index) in registros" :key="index">
          <listagem :titulo="registro.titulo" :columns="columns" :listagem-data="registro.valores" :icon="registro.icone"></listagem>
          <el-col style="padding-left: 0" v-if="index === 0" :span="20">
          <span class="font total">TOTAL DÉBITOS:</span>
          </el-col>
          <el-row style="margin-bottom: 25px">
          <el-col v-if="index === 0" :span="4">
            <span class="valor-total">R$ {{registro.valorTotal}}</span>
          </el-col>
            <el-col v-if="index === 1" :span="20">
              <span class="font total">TOTAL CRÉDITOS:</span>
            </el-col>
          <el-col v-if="index === 1" :span="4">
            <span class="valor-total">R$ {{registro.valorTotal}}</span>
          </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col class="align-menu" :span="11">
        <menu-vertical :columns="itensMenu"></menu-vertical>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import { mapState } from 'vuex'
import moment from 'moment'
import Listagem from '@/components/Listagem/Listagem'
import textSmall from '@/components/Listagem/textSmall'
import floatItem from '@/components/Listagem/floatItem'
import MenuVertical from '@/components/MenuVertical/MenuVertical'
export default {
  data () {
    return {
      resumoCobranca: null,
      registros: null,
      linkPDf: '',
      columns: [
        { small: 'id', field: 'descricao', component: textSmall },
        { field: 'valor', component: floatItem }
      ],
      itensMenu: [
        {
          title: 'Imprimir',
          action: this.imprimirPagina
        }
      ]
    }
  },
  components: {
    MenuVertical,
    Listagem,
    FuncionalidadeHeader
  },
  computed: {
    ...mapState('SetupApp', ['apiFuncionalidade', 'funcionalidade']),
    tituloDetalhe () {
      return this.$route.query.tituloDetalhe
    },
    vencimento () {
      const value = this.$route.query.vencimento
      return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    parseValor () {
      return this.$route.query.valor || 0
    }
  },
  methods: {
    async listaCobranca () {
      const response = await this.apiFuncionalidade.resumoCobranca({
        payload: {
          idTitulo: this.$route.query.idTitulo,
          codigoTitulo: this.$route.query.codigoTitulo
        },
        loading: true,
        handlerErrorIgnore: [404]
      })
      this.resumoCobranca = response.data
      this.registros = response.data.registros
    },
    async resumoPdf () {
      this.itensMenu.push({
        title: 'Salvar',
        action: this.salvarResumo
      })
      const response = await this.apiFuncionalidade.resumoCobrancaPdf({
        payload: {
          idTitulo: this.$route.query.idTitulo,
          codigoTitulo: this.$route.query.codigoTitulo
        },
        loading: true,
        handlerErrorIgnore: [404]
      })

      if (response.data.url) {
        this.linkPDf = response.data.url
      }

      if (response.data.base64) {
        this.linkPDfBase = response.data.base64
      }
    },
    salvarResumo () {
      if (this.linkPDfBase) {
        window.open(this.baseToUrl(this.linkPDfBase), '_blank')
      } else if (this.linkPDf) {
        window.open(this.linkPDf, '_blank')
      }
    },
    imprimirPagina () {
      window.print()
    },
    baseToUrl (base) {
      const binaryPDF = window.atob(base)
      const byteArray = new Uint8Array(binaryPDF.length)
      for (let i = 0; i < binaryPDF.length; i++) {
        byteArray[i] = binaryPDF.charCodeAt(i)
      }
      const blob = new Blob([byteArray], { type: 'application/pdf' })

      return URL.createObjectURL(blob)
    }
  },
  async created () {
    if (this.funcionalidade.parametros && this.funcionalidade.parametros.visualizarResumoCobranca) await this.listaCobranca()
    if (this.funcionalidade.parametros && this.funcionalidade.parametros.visualizarResumoCobrancaPdf) await this.resumoPdf()
  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
@media print {
  .align-menu {
    display: none;
  }
  .col-print {
    width: 97%;
  }
}
#func-14-resumo-cobranca {
  padding: 0px 25px;
}
.font {
  font-family: "Open Sans", SansSerif;
  color: #333333;
  text-align: left;
  letter-spacing: 0px;
  display: block;
}
.cobranca-title {
  font-size: 20px;
  font-weight: 600;
}
.cobranca-vencimento {
  font-size: 14px;
}
.total {
  font-weight: 600;
  font-size: 14px;
  margin-left: 44px;
}
.valor-total {
  float: right;
  margin-right: 15px;
  font-weight: 600;
}
.align-right {
  float: right;
  right: 20px;
  position: relative;
}
.align-menu {
  top: 10px;
  position: relative;
}
</style>
